import { format } from 'date-fns';
import logger from 'util/logger';

export function firstVisitData() {
  const FIRST_VISIT_LOCAL_STORAGE_KEY = 'JUKE_FIRST_VISIT';
  const FIRST_VISIT_URL_LOCAL_STORAGE_KEY = 'JUKE_FIRST_VISIT_URL';
  let firstVisit = {
    date: localStorage.getItem(FIRST_VISIT_LOCAL_STORAGE_KEY),
    url: localStorage.getItem(FIRST_VISIT_URL_LOCAL_STORAGE_KEY),
  };

  if (!firstVisit.date && !firstVisit.url) {
    firstVisit = {
      date: format(Date.now(), 'yyyyMMdd'),
      url:
        window.location.pathname === '/'
          ? `${window.location.host}/home`
          : `${window.location.host}${window.location.pathname}`,
    };
    localStorage.setItem(FIRST_VISIT_LOCAL_STORAGE_KEY, firstVisit.date);
    localStorage.setItem(FIRST_VISIT_URL_LOCAL_STORAGE_KEY, firstVisit.url);
  }
  return firstVisit;
}

/**
 * Wait with first pageview event for optimizely to be loaded
 */
export function trackFirstPageView(_attempt) {
  const attempt = !_attempt ? 1 : _attempt + 1;
  logger.warn(`check for optimizely | attempt: ${attempt}`);
  if (!window.optimizelyReady && attempt < 10) {
    return setTimeout(trackFirstPageView, 200, attempt);
  }
  // Timeout is needed to give enough time for optimizely to be ready
  return setTimeout(() => {
    window.Taq.push([
      'track',
      'view',
      {
        event_name: 'first_pageview',
        event_category: 'first',
        event_action: 'pageview',
        event_label: window.location.href,
      },
    ]);

    window.Taq.push(['setDataLayer', { call_noninteractionhit: true }, false]);
  }, 1000);
}
